import { apiToken } from '@/utils/api'
import store from '@/store'

function login(email, password) {
  const toAuth = process.env.NODE_ENV === 'development' ? '/auth2' : '/auth'
  return apiToken
    .post(toAuth, {
      username: email,
      password: password
    })
    .then(res => {
      if (res.code == 200) {
        const info = {
          employeeId: res.data.userInfo.employee_id,
          employeeImage: res.data.userInfo.employee_image,
          fullname: res.data.userInfo.fullname_th,
          fullname_en: res.data.userInfo.fullname_en,
          username: res.data.userInfo.username,
          comp_no: res.data.userInfo.comp_no,
          role: res.data.userInfo.role_code_array,
          bu_no: res.data.userInfo.bu_no,
          bu_name: res.data.userInfo.bu_name,
          section: res.data.userInfo.section,
          department: res.data.userInfo.department,
          division: res.data.userInfo.division,
          telephone: res.data.userInfo.telephone,
          showTabMonitor: res.data.showTabMonitor,
          roleCode: res.data.userRole.role_code
        }
        localStorage.setItem('token', res.data.accessToken)
        localStorage.setItem('info', JSON.stringify(info))
        localStorage.setItem('role', JSON.stringify(res.data.userRole))
        localStorage.setItem('wfRole', JSON.stringify(res.data.wfRolesMember))
        store.commit('global/setEmployeeDefault', res.data.userInfo.employee_id)
        store.dispatch('global/loadOptionFilterList')
        return res
      } else {
        return res
      }
    })
}

function logout(token, info) {
  apiToken
    .post('/logout', {
      access_token: token,
      employee_id: info?.employeeId
    })
    .then(res => {
      if (res.code == 200) {
        localStorage.removeItem('token')
        localStorage.removeItem('info')
        localStorage.removeItem('role')
        localStorage.removeItem('wfRole')
        localStorage.removeItem('menus')
        return true
      } else {
        return false
      }
    })
    .catch(e => {
      return false
    })
}

async function checkInMenus(modules) {
  const menus = await modules.menus.map(menu => {
    const subMenu = menu.subMenus.map(submenu => {
      return {
        active: false,
        title: submenu.title,
        pageName: submenu.subMenu,
        icon: submenu.icon,
        link: submenu.link,
        apiUrl: submenu.apiUrl
      }
    })
    return {
      active: false,
      activeDropdown: false,
      title: menu.title,
      pageName: menu.menu,
      icon: menu.icon,
      link: menu.link,
      subMenu: subMenu
    }
  })

  localStorage.setItem('menus', JSON.stringify(menus))
  return menus
}

function checkOutMenus(menus) {
  localStorage.removeItem('menus')
}

export default {
  login,
  logout,
  checkInMenus,
  checkOutMenus
}
